import * as React from "react";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const accessibleIconMapping = {
  success: <CheckCircleOutlineIcon titleAccess="Success" />,
  info: <InfoOutlinedIcon titleAccess="Information" />,
  warning: <ReportProblemOutlinedIcon titleAccess="Warning" />,
  error: <ErrorOutlineIcon titleAccess="Error" />
};

const AccessibleAlert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert ref={ref} iconMapping={accessibleIconMapping} {...props} />
));
AccessibleAlert.displayName = "AccessibleAlert";

export { AccessibleAlert };
